import { Component, Input, OnChanges } from '@angular/core';
import { EntreeJournal, JournalService } from 'src/app/core/services/entities/journal.service';
import { JournalUtil } from './journal.util';

/** Bloc « Activité récente » d'une fiche : 5 dernières actions sur l'élément, « Tout voir » vers le journal filtré */
@Component({
  selector: 'bay-activite-recente',
  template: `
    <section class="card border-0 shadow-sm" style="border-radius:20px;" aria-label="Activité récente" data-etat="activite-recente">
      <div class="card-body p-4">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="fw-bold mb-0" style="color:#374151;">Activité récente</h6>
          <a *ngIf="entrees.length" class="small fw-semibold text-success text-decoration-none" routerLink="/journal"
             [queryParams]="{ elementType: elementType, elementId: elementId }">Tout voir</a>
        </div>
        <div *ngIf="chargement" class="text-muted small py-2">Chargement…</div>
        <div *ngIf="erreur" class="text-muted small py-2" role="status">{{ erreur }}</div>
        <p *ngIf="!chargement && !erreur && !entrees.length" class="text-muted small mb-0">Aucune action enregistrée pour l'instant.</p>
        <bay-entree-journal *ngFor="let e of entrees" [entree]="e" [avecJour]="true" [sansLien]="true"></bay-entree-journal>
      </div>
    </section>
  `
})
export class ActiviteRecenteComponent implements OnChanges {
  /** Type serveur : LotVolaille, Bassin, Pisciculture, Troupeau, Animal, Culture, StockArticle, Equipement */
  @Input() elementType = '';
  @Input() elementId?: number | string | null;

  entrees: EntreeJournal[] = [];
  chargement = false;
  erreur: string | null = null;
  private dernier = '';

  constructor(private journal: JournalService) {}

  ngOnChanges(): void {
    const cle = `${this.elementType}/${this.elementId}`;
    if (!this.elementType || this.elementId == null || cle === this.dernier) { return; }
    this.dernier = cle;
    this.chargement = true;
    this.erreur = null;
    this.journal.auMoins(c => this.journal.pageElement(this.elementType, this.elementId!, c, 5), 5).subscribe({
      next: p => { this.entrees = p.entrees.slice(0, 5); this.chargement = false; },
      error: e => { this.entrees = []; this.chargement = false; this.erreur = JournalUtil.messageErreur(e); }
    });
  }
}
